<template>
  <div v-if="termsIndex" class="container">
    <LayoutColumns hide-left>
      <template v-slot:main>
        <h1 class="headline-m col-span-6 sm:col-span-12 mt-8">
          {{ termsIndex.attributes.Title }}
        </h1>
        <p class="standfirst col-span-6 sm:col-span-10 mb-5 md:mb-8">
          {{ termsIndex.attributes.Subtitle }}
        </p>
      </template>
    </LayoutColumns>

    <LayoutColumns :alignment="'start'" hide-left>
      <template v-slot:main>
        <div class="content-dynamic">
          <div v-html="termsIndex.attributes.Body" />
        </div>
        <ul>
          <div class="content-dynamic">
            <li v-for="term in terms" :key="term.id">
              <NuxtLink
                :to="{
                  name: 'term',
                  params: { termId: term.attributes?.Slug },
                }"
              >
                {{ term.attributes.Title }}
              </NuxtLink>
              <p class="text-gray-500">
                {{ $t('LatestUpdated') }}
                <span class="lowercase">
                  {{
                    formatDate(new Date(term.attributes?.LatestUpdate))
                  }}</span
                >
              </p>
              <br />
            </li>
          </div>
        </ul>
      </template>
      <template v-slot:right>
        <div class="border-solid border-2 border-gray-50 rounded-xl p-8">
          <img
            class="w-auto h-full"
            :src="termsIndex.attributes.Logo.data.attributes.url"
          />
          <br />
          <div
            class="content-dynamic md:mb-4"
            v-html="termsIndex.attributes.ContactText"
          />
          <ul>
            <li>
              {{
                $t('PhoneShort').charAt(0).toUpperCase() +
                $t('PhoneShort').slice(1)
              }}
              <b>{{ termsIndex.attributes.ContactTelephone }}</b>
            </li>
            <li>
              {{ $t('Email') }}:
              <b
                ><a :href="'mailto:' + termsIndex.attributes.ContactEmail">{{
                  termsIndex.attributes.ContactEmail
                }}</a></b
              >
            </li>
          </ul>
        </div>
      </template>
    </LayoutColumns>
  </div>
</template>

<script setup lang="ts">
import type { StrapiLocale } from '@nuxtjs/strapi'

type TermsIndex = {
  Body: string
  ContactEmail: string
  ContactTelephone: string
  ContactText: string
  Logo: {
    data: {
      attributes: {
        url: string
      }
      id: number
    }
  }
  Title: string
  Subtitle: string
  createdAt: string
  terms: {
    data: {
      id: number
      attributes: {
        Body: string
        Title: string
        Slug: string
        LatestUpdate: string
      }
    }[]
  }
}

const config = useRuntimeConfig()
const { findOne } = useStrapi()

const { data: termsIndex } = await useAsyncData(async () => {
  return (
    await findOne<TermsIndex>('terms-index', '', {
      locale: config.public.site.strapilocale as StrapiLocale,
      populate: '*',
    })
  ).data
})

const terms = computed(() => {
  return termsIndex.value?.attributes.terms.data
})

useHead({
  title: termsIndex.value?.attributes.Title,
})
</script>
